// extracted by mini-css-extract-plugin
export default {"container":"nh0WlD","border":"ZClu0i","rotate":"zANP8d","paused":"dLqOSV"};